import {uniqueId} from 'lodash'
import document from '@/assets/images/document.png'

const contactFinancesTable = {
  columns: {
    getColumnsData: 'contactsFinancesColumnsData',
    setColumnsData: 'setContactsFinancesColumnsData'
  },
  rows: {
    getRowsData: 'contactsFinancesRowsData',
    setRowsData: 'setContactsFinancesRowsData'
  }
}

const columns = [
  {
    property: 'soaStatus',
    sortByColumn: true,
    listName: 'statusSoa',
    list: []
  },
  {
    title: 'Proforma No.',
    property: 'number',
    hover: true
  },
  {
    title: 'Date Invoiced',
    type: 'date',
    property: 'issueDate'
  },
  {
    title: 'Total Invoiced',
    property: 'totalInvoicedAed'
  },
  {
    title: 'Date Received',
    type: 'date',
    property: 'paymentDate'
  },
  // {
  //   title: 'Tax Invoice',
  //   center: true,
  //   viewMode: 'checkbox',
  //   property: 'taxInvoice',
  //   style: 'taxCheckbox'
  // },
  {
    title: 'Tax Inv No.',
    property: 'taxInvoiceNumber',
    style: 'taxInvoice'
  },
  {
    type: 'upload',
    upload: true,
    icon: document,
    actions: {},
    style: 'taxInvoiceFile'
  },
  {
    title: 'Received , AED',
    property: 'received'
  },
  {
    title: 'Balance, AED',
    property: 'soaBalance'
  },
  // {
  //   title: 'Status',
  //   property: 'received',
  //   dependence: 'totalInvoicedAed',
  //   statusDependence: true,
  //   hideHighlight: true
  // },
  {
    title: 'Amount, AED',
    property: 'received',
    isNumber: true,
    dependence: 'totalInvoicedAed',
    statusBackground: true
  }
]

const prefix = 'contact_finances_column_'
const contactFinancesTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  col.typeTable = 'contactFinances'
  col.actions = {
    edit: true
  }
  return col
})

export {
  contactFinancesTable,
  contactFinancesTableColumns
}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/contactsFinancesTable.js